<!-- Main Content Area - Split Layout -->
<div class="main-layout" [class.split-view]="activePanel !== null">
  <!-- LEFT: Component Display Area -->
  <div class="content-area" [class.component-active]="activePanel !== null">
    <!-- Show selected component -->
    <div *ngIf="activePanel" class="active-component">
      <div class="component-content">
        <!-- Single ListingComponent handles Product/Service/Events/Reviews/Charity -->
        <app-listing
          *ngIf="isListingPanel(activePanel)"
          [initialType]="mapPanelToListingType(activePanel)"
          [cardId]="card?.id"
          [preloadedListings]="loadedListings"
        >
        </app-listing>

        <!-- Panels not handled by ListingComponent -->
        <app-payments *ngIf="activePanel === 'payments'"></app-payments>
        <app-gallery *ngIf="activePanel === 'gallery'"></app-gallery>
        <app-settings *ngIf="activePanel === 'settings'"></app-settings>
        <app-about *ngIf="activePanel === 'about'" [card]="card"></app-about>
        <app-members
          *ngIf="activePanel === 'members'"
          [card]="card"
        ></app-members>
      </div>
    </div>

    <!-- Show default cards when no component selected -->
    <div *ngIf="!activePanel" class="default-content">
      <div class="container py-4 position-relative z-1">
        <div class="card-wrapper mx-auto" style="margin-top: 100px">
          <div class="d-flex align-items-center">
            <h1 class="mb-5">
              <strong>{{
                card?.business_info?.businessName ||
                  card?.contact_info?.contactName
              }}</strong>
            </h1>
            <button
              mat-icon-button
              color="primary"
              class="ms-2 mb-5"
              (click)="openEditForm(card)"
              matTooltip="Edit card details"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </div>

          <!-- Mobile: Flip Card -->
          <div
            class="flip-card d-lg-none"
            [class.flipped]="flipped"
            style="height: 300px; max-width: 350px; margin: 0 auto"
          >
            <div class="flip-card-inner">
              <!-- Front: Business -->
              <div
                class="flip-card-front d-flex flex-column align-items-center justify-content-center p-3"
                style="height: 100%"
              >
                <i class="bi bi-building fs-2 mb-2"></i>
                <h6 class="text-uppercase letter-spacing-md opacity-75 mb-2">
                  Business
                </h6>
                <h5 class="text-center fw-bold mt-1 mb-2">
                  {{ card?.business_info?.businessName ' }}
                </h5>
                <p class="small text-center mt-2 px-2 mb-3">
                  <strong>Industry:</strong> {{ card?.industry }}<br />
                  <strong>Type:</strong> {{ card?.type }}
                </p>
                <button
                  class="btn btn-light btn-sm mt-auto"
                  (click)="flipCard()"
                >
                  View Contact
                </button>
              </div>

              <!-- Back: Personal -->
              <div
                class="flip-card-back d-flex flex-column align-items-center justify-content-center p-3"
                style="height: 100%"
              >
                <div class="avatar mb-2">
                  <span
                    class="d-inline-block p-2 rounded-circle bg-opacity-20"
                    >{{ getInitials(card?.personalInfo?.fullName || "") }}</span
                  >
                </div>
                <h6 class="text-uppercase letter-spacing-md opacity-75 mb-2">
                  Contact
                </h6>
                <h5 class="text-center fw-bold mt-1 mb-2">
                  {{ card?.personalInfo?.fullName }}
                </h5>
                <p class="small text-center mt-2 px-2 mb-3">
                  <strong>Email:</strong>
                  {{ card?.contact?.email || card?.email }}<br />
                  <strong>Phone:</strong>
                  {{ card?.contact?.phone || card?.phone }}
                </p>
                <button
                  class="btn btn-light btn-sm mt-auto"
                  (click)="flipCard()"
                >
                  Back
                </button>
              </div>
            </div>
          </div>

          <!-- Grid of Titles in Default Content -->
          <div class="container mt-5">
            <div class="row row-cols-2 row-cols-md-3 g-3">
              <!-- Products Card -->
              <div class="col">
                <div
                  (click)="toggleProductsPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-box-seam fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">
                      Products
                    </h6>
                  </div>
                </div>
              </div>

              <!-- Services Card -->
              <div class="col">
                <div
                  (click)="toggleServicesPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-gear fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">
                      Services
                    </h6>
                  </div>
                </div>
              </div>

              <!-- Events Card -->
              <div class="col">
                <div
                  (click)="toggleEventsPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-calendar-event fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">Events</h6>
                  </div>
                </div>
              </div>

              <!-- Reviews Card -->
              <div class="col">
                <div
                  (click)="toggleReviewsPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-star fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">Reviews</h6>
                  </div>
                </div>
              </div>

              <!-- Projects Card -->
              <div class="col">
                <div
                  (click)="toggleProjectsPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-kanban fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">
                      Projects
                    </h6>
                  </div>
                </div>
              </div>

              <!-- Charity Card -->
              <div class="col">
                <div
                  (click)="toggleCharityPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-heart fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">Charity</h6>
                  </div>
                </div>
              </div>

              <!-- Payments Card -->
              <div class="col">
                <div
                  (click)="togglePaymentsPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-credit-card fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">
                      Payments
                    </h6>
                  </div>
                </div>
              </div>

              <!-- Gallery Card -->
              <div class="col">
                <div
                  (click)="toggleGalleryPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-images fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">Gallery</h6>
                  </div>
                </div>
              </div>

              <!-- Settings Card -->
              <div class="col">
                <div
                  (click)="toggleSettingsPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-sliders fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">
                      Settings
                    </h6>
                  </div>
                </div>
              </div>

              <!-- Members Card - Only show for Business cards -->
              <div class="col" *ngIf="card?.type === 'Business'">
                <div
                  (click)="toggleMembersPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-people fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">Members</h6>
                  </div>
                </div>
              </div>

              <!-- About Card -->
              <div class="col">
                <div
                  (click)="toggleAboutPanel()"
                  class="card text-decoration-none text-dark shadow-sm h-100 cursor-pointer card-hover"
                  [class.active]="activePanel === 'about'"
                  style="border-radius: 8px; min-height: 120px"
                >
                  <div
                    class="card-body d-flex flex-column justify-content-center align-items-center p-3"
                  >
                    <i class="bi bi-info-circle fs-3 mb-2 text-primary"></i>
                    <h6 class="card-title text-center fw-bold mb-0">About</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- RIGHT: Navigation Sidebar (ALWAYS VISIBLE) -->
  <div class="navigation-sidebar sidebar-active">
    <div class="sidebar-card-info" style="border-radius: 10px">
      <div class="company-info">
        <h4>
          {{
            card?.business_info?.businessName || card?.contact_info?.contactName
          }}
        </h4>
        <p><strong>Industry:</strong> {{ card?.industry }}</p>
        <p><strong>Type:</strong> {{ card?.type }}</p>
      </div>
    </div>

    <div class="navigation-grid">
      <!-- Nav cards -->
      <div
        *ngIf="card?.permissions?.product === 'show'"
        class="nav-card"
        [class.active]="activePanel === 'products'"
        (click)="toggleProductsPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-box-seam"></i><span>Products</span>
        </div>
      </div>
      <div
        *ngIf="card?.permissions?.service === 'show'"
        class="nav-card"
        [class.active]="activePanel === 'services'"
        (click)="toggleServicesPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-gear"></i><span>Services</span>
        </div>
      </div>
      <div
        *ngIf="card?.permissions?.events === 'show'"
        class="nav-card"
        [class.active]="activePanel === 'events'"
        (click)="toggleEventsPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-calendar-event"></i><span>Events</span>
        </div>
      </div>
      <div
        *ngIf="card?.permissions?.reviews === 'show'"
        class="nav-card"
        [class.active]="activePanel === 'reviews'"
        (click)="toggleReviewsPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-star"></i><span>Reviews</span>
        </div>
      </div>
      <div
        *ngIf="card?.permissions?.charity === 'show'"
        class="nav-card"
        [class.active]="activePanel === 'charity'"
        (click)="toggleCharityPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-heart"></i><span>Charity</span>
        </div>
      </div>

      <div
        *ngIf="card?.permissions?.projects === 'show'"
        class="nav-card"
        [class.active]="activePanel === 'projects'"
        (click)="toggleProjectsPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-kanban"></i><span>Projects</span>
        </div>
      </div>
      <div
        *ngIf="card?.permissions?.payments === 'show'"
        class="nav-card"
        [class.active]="activePanel === 'payments'"
        (click)="togglePaymentsPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-credit-card"></i><span>Payments</span>
        </div>
      </div>
      <div
        *ngIf="card?.permissions?.gallery === 'show'"
        class="nav-card"
        [class.active]="activePanel === 'gallery'"
        (click)="toggleGalleryPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-images"></i><span>Gallery</span>
        </div>
      </div>
      <div
        *ngIf="
          card?.permissions?.members === 'show' && card?.type === 'Business'
        "
        class="nav-card"
        [class.active]="activePanel === 'members'"
        (click)="toggleMembersPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-people"></i><span>Members</span>
        </div>
      </div>
      <div
        class="nav-card"
        [class.active]="activePanel === 'settings'"
        (click)="toggleSettingsPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-sliders"></i><span>Settings</span>
        </div>
      </div>
      <div
        class="nav-card"
        [class.active]="activePanel === 'about'"
        (click)="toggleAboutPanel()"
      >
        <div class="nav-card-content">
          <i class="bi bi-info-circle"></i><span>About</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit Modal (Replaces Create Modal) -->
  <div
    *ngIf="showEditForm"
    class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-overlay"
    style="background: rgba(0, 0, 0, 0.6); z-index: 100"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6">
          <mat-card
            class="shadow-lg border-0"
            style="border-radius: 10px; max-height: 90vh; background: #fffbe6"
          >
            <mat-card-header
              class="d-flex justify-content-between align-items-center border-bottom px-4 py-3"
              style="background: #ffe699"
            >
              <mat-card-title class="fw-bold"
                ><mat-icon class="me-2 text-primary">edit</mat-icon>Edit
                vCard</mat-card-title
              >
              <button mat-icon-button (click)="closeEditForm()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-card-header>

            <!-- Error Display -->
            <div *ngIf="updateError" class="px-4 pt-3">
              <mat-card
                class="shadow-sm border-0"
                style="
                  background-color: #f8d7da;
                  border-left: 4px solid #dc3545;
                "
              >
                <mat-card-content class="p-3">
                  <div class="d-flex align-items-start">
                    <mat-icon class="me-2 text-danger">error</mat-icon>
                    <div class="flex-grow-1">
                      <div class="fw-bold text-danger">
                        {{ updateError.title || "Error" }}
                      </div>
                      <div class="text-danger">{{ updateError.message }}</div>
                      <div class="small text-muted" *ngIf="updateError.details">
                        {{ updateError.details }}
                      </div>
                    </div>
                    <button
                      type="button"
                      mat-icon-button
                      (click)="updateError = null"
                      class="text-danger"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <mat-card-content
              class="px-4 py-3 overflow-auto"
              style="max-height: 60vh"
            >
              <form (ngSubmit)="saveCardEdits()" #editForm="ngForm">
                <div class="row g-4">
                  <div class="col-md-6">
                    <h6 class="text-primary fw-bold d-flex align-items-center">
                      <mat-icon class="me-2">person</mat-icon> Contact
                      Information
                    </h6>
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Full Name</mat-label>
                      <input
                        matInput
                        [(ngModel)]="editCardForm.name"
                        name="name"
                        required
                        placeholder="Enter your full name"
                      />
                      <mat-icon matSuffix>person</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100 mt-3">
                      <mat-label>Email</mat-label>
                      <input
                        matInput
                        type="email"
                        [(ngModel)]="editCardForm.email"
                        name="email"
                        required
                        placeholder="your.email@example.com"
                      />
                      <mat-icon matSuffix>email</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100 mt-3">
                      <mat-label>Phone</mat-label>
                      <input
                        matInput
                        [(ngModel)]="editCardForm.phone"
                        name="phone"
                        required
                        placeholder="+1 234 567 8900"
                      />
                      <mat-icon matSuffix>phone</mat-icon>
                    </mat-form-field>
                  </div>

                  <div class="col-md-6">
                    <h6 class="text-primary fw-bold d-flex align-items-center">
                      <mat-icon class="me-2">credit_card</mat-icon> Card
                      Information
                    </h6>
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Card Type</mat-label>
                      <mat-select
                        [(value)]="editCardForm.type"
                        [disabled]="true"
                      >
                        <mat-option
                          *ngFor="let option of cardTypeOptions"
                          [value]="option.value"
                          >{{ option.label }}</mat-option
                        >
                      </mat-select>
                      <mat-icon matSuffix>business_center</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100 mt-3">
                      <mat-label>Industry</mat-label>
                      <mat-select [(value)]="editCardForm.industry">
                        <mat-option
                          *ngFor="let option of industryOptions"
                          [value]="option.value"
                          >{{ option.label }}</mat-option
                        >
                      </mat-select>
                      <mat-icon matSuffix>domain</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100 mt-3">
                      <mat-label>Handler/Username</mat-label>
                      <input
                        matInput
                        [(ngModel)]="editCardForm.handler"
                        name="handler"
                        disabled
                        pattern="^[a-zA-Z0-9_-]{3,30}$"
                        required
                        placeholder="yourname123"
                      />
                      <mat-icon matSuffix>alternate_email</mat-icon>
                      <mat-hint>Cannot be changed</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </mat-card-content>

            <mat-card-actions
              class="d-flex justify-content-end gap-3 px-4 py-3 border-top bg-light"
              style="
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
              "
            >
              <button mat-button (click)="closeEditForm()" class="px-4">
                Cancel
              </button>
              <button
                mat-raised-button
                color="primary"
                (click)="saveCardEdits()"
                [disabled]="updating"
                class="px-4"
              >
                <div class="d-flex align-items-center">
                  <mat-spinner
                    *ngIf="updating"
                    diameter="20"
                    class="me-2"
                  ></mat-spinner>
                  <mat-icon *ngIf="!updating" class="me-2">save</mat-icon>
                  <span>{{ updating ? "Saving..." : "Save Changes" }}</span>
                </div>
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
